"use-strict";

export class Menu {
    menu = null;
    menuClose = null;
    menuButton = null;
    operating = false;

    navOpenClass =  'nav--open';

    constructor() {
        this.init();
    }

    init() {
        this.menu = document.getElementById('nav');
        this.menuClose = document.getElementById('nav-close-button');
        this.menuButton = document.getElementById('nav-button');

        this.handleEvents();
    }

    isOpen() {
        return this.menu.classList.contains(this.navOpenClass);
    }

    open() {
        this.menu.classList.add(this.navOpenClass);
    }

    close() {
        this.menu.classList.remove(this.navOpenClass);
    }

    toggle() {
        if (!this.isOpen()) {
            this.open();
        } else {
            this.close();
        }
    }

    clickEventMenuButton(e) {
        if (this.operating) {
            return;
        }

        this.operating = true;

        this.toggle();

        setTimeout(() => {
            this.operating = false;
        }, 100);
    }

    handleEvents() {
        this.menuButton.addEventListener('click', e => this.clickEventMenuButton(e));
        this.menuClose.addEventListener('click', e => this.close(e));
    }
}
